import { useEffect } from "react";
import alertCircle from "@/assets/images/alert-circle.svg";
import { cn } from "@/utils/utils";

type ErrorMessageProps = {
    id?: string | undefined;
    error?: string | undefined;
    className?: string;
};

export default function SimpleErrorMessage({
    ...props
}: ErrorMessageProps) {

    if (!props.error) {
        return;
    }

    useEffect(() => {
        if (props.error && props.id) {
            document.getElementById(props.id)?.focus();
        }
    }, [props.error]);

    return (
        <div className={cn(props.className, "w-full inline-flex align-items-center ")}>
            <img src={alertCircle} alt="" className="mt-2 h-8 w-8" />
            <span
                id={props.id}
                tabIndex={10}
                aria-live={props.error ? "assertive" : "off"}
                aria-hidden={!props.error}
                role="alert"
                className="text-[var(--redCredentials)] text-xs ml-2 mt-2"
                dangerouslySetInnerHTML={{ __html: props.error || "" }}>
            </span>
        </div>
    );
}; 
